import React, { useState } from 'react'
import DOMPurify from 'isomorphic-dompurify'
import PropTypes from 'prop-types'
import Image from '../Image/Image'
import Modal from 'react-modal'
import { mediaQueryHOC } from '../../adapters/helpers/Hooks'
import {Constants, YoutubeVideoConstants} from '../../adapters/helpers/Constants';
import classNames from 'classnames'

const MiniContentBlock = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const { document, isSmall } = props
    const className = document?.fields?.className
    const desktopBannerImage = document?.fields?.desktopBannerImage
    const mobileBannerImage = document?.fields?.mobileBannerImage
    const eyebrow = document?.fields?.eyebrow
    const headerText = document?.fields?.headerText
    const subText = document?.fields?.subText
    const secondSubText = document?.fields?.secondSubText
    const disclaimer = document?.fields?.disclaimer
    const bannerBackgroundColour = document?.fields?.bannerBackgroundColour
    const textColour = document?.fields?.textColour
    const headerTextStyle = document?.fields?.headerTextStyle
    const subTextStyle = document?.fields?.subTextStyle
    const secondSubTextStyle = document?.fields?.secondSubTextStyle
    const videoId = document?.fields?.videoId || null
    const bannerImagePosition = document?.fields?.bannerImagePosition
    const linkButton = document?.fields?.linkButton || null
    const headerTextLevel = document?.fields?.headerTextLevel;

    const textStyle = {
        color: textColour,
        textAlign: isSmall ? 'center' : 'left',
        width: '100%',
    }
    const customStyles = {
        overlay: {
            position: 'fixed',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
            border: 'none',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: '0',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '100rem',
            width: '90%',
        },
    }

    const getUpdatedStyles = (styleType) => {
        const styleObject = isSmall ? styleType?.mobile : styleType?.desktop

        return {
            ...textStyle,
            ...styleObject,
        }
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    const renderVideo = () => {
        return <iframe title={YoutubeVideoConstants.title} src={`${YoutubeVideoConstants.url}${videoId}`}></iframe>
    }

    const DynamicHeader = ({ className,level='2', style, text }) => {
        const HeaderTag = `h${level}`;
    
        return (
          <HeaderTag
            className={className}
            style={style}
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
          />
        );
    };

    const renderImage = () => {
        return (
            <div className='ob-mini-content-image-container'>
                <Image
                    className={isSmall ? 'ob-mini-content-mobile-image' : 'ob-mini-content-dektop-image'}
                    image={isSmall ? mobileBannerImage : desktopBannerImage}
                    altText={isSmall ? mobileBannerImage?.fields?.alternateText : desktopBannerImage?.fields?.alternateText}
                />
            </div>
        )
    }

    const renderText = () => {
        return (
            <div className='ob-mini-content-text-area-wrapper' style={{ backgroundColor: bannerBackgroundColour }}>
                {eyebrow && <p className='ob-mini-content-eyebrow' style={textStyle} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(eyebrow) }} />}
                {headerText && <DynamicHeader className='ob-mini-content-header' level={headerTextLevel} style={getUpdatedStyles(headerTextStyle)} text={headerText} />}
                {subText && <p className='ob-mini-content-sub-text' style={getUpdatedStyles(subTextStyle)} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subText) }} />}
                {secondSubText && (
                    <p
                        className='ob-mini-content-sub-text'
                        style={getUpdatedStyles(secondSubTextStyle)}
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(secondSubText),
                        }}
                    />
                )}
                {linkButton?.fields?.url && (
                    <a
                        className={classNames('miniContentLinkBtn', linkButton?.fields?.className, linkButton?.fields?.url?.includes('http') ? 'event_outbound_link' : 'event_internal_link')}
                        href={linkButton?.fields?.url}
                        data-action-detail={linkButton?.fields?.url}
                    >
                        {linkButton?.fields?.title}
                    </a>
                )}
                {disclaimer && <p className='ob-mini-content-disclaimer' style={textStyle} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(disclaimer) }} />}
            </div>
        )
    }
    const renderMiniContentBlock = () => {
        return (
          <>
            {bannerImagePosition && (
              <>
                {(bannerImagePosition === Constants.bannerImagePositionLeft ||
                  bannerImagePosition === Constants.bannerImagePositionUp) &&
                  renderImage()}
                {renderText()}
                {bannerImagePosition === Constants.bannerImagePositionRight &&
                  renderImage()}
              </>
            )}
            {!bannerImagePosition && (
              <>
                {renderImage()}
                {renderText()}
              </>
            )}
          </>
        );
      };

    return (
        <>
            {isModalOpen && (
                <Modal isOpen={isModalOpen} onRequestClose={closeModal} style={customStyles} htmlOpenClassName={'ob-carousel-tab-item-video'}>
                    <div className={'ob-youtube-video-block'} style={{ paddingBottom: '56%' }}>
                        {renderVideo()}
                    </div>
                </Modal>
            )}
            <div className={`ob-mini-content-block ${className}`}>
                {!isSmall && renderMiniContentBlock()}
                {isSmall && (
                    <>
                        {renderImage()}
                        {renderText()}
                    </>
                )}
            </div>
        </>
    )
}

MiniContentBlock.propTypes = {
    document: PropTypes.object,
    isSmall: PropTypes.boolean,
}
export default mediaQueryHOC(MiniContentBlock)
